import { FC } from 'react'

import { PRIMARY_DARKER } from '../../utils/constants'

interface LinkIconProps {
  fill?: string
}

const ExternalLinkIcon: FC<LinkIconProps> = ({ fill = PRIMARY_DARKER }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.125 2.5C2.95924 2.5 2.80027 2.56585 2.68306 2.68306C2.56585 2.80027 2.5 2.95924 2.5 3.125V11.875C2.5 12.0408 2.56585 12.1997 2.68306 12.3169C2.80027 12.4342 2.95924 12.5 3.125 12.5H11.875C12.0408 12.5 12.1997 12.4342 12.3169 12.3169C12.4342 12.1997 12.5 12.0408 12.5 11.875V8.58563C12.5 8.41987 12.5658 8.26089 12.6831 8.14368C12.8003 8.02647 12.9592 7.96063 13.125 7.96063C13.2908 7.96063 13.4497 8.02647 13.5669 8.14368C13.6842 8.26089 13.75 8.41987 13.75 8.58563V11.875C13.75 12.3723 13.5525 12.8492 13.2008 13.2008C12.8492 13.5525 12.3723 13.75 11.875 13.75H3.125C2.62772 13.75 2.15081 13.5525 1.79917 13.2008C1.44754 12.8492 1.25 12.3723 1.25 11.875V3.125C1.25 2.62772 1.44754 2.15081 1.79917 1.79917C2.15081 1.44754 2.62772 1.25 3.125 1.25H6.26062C6.42639 1.25 6.58536 1.31585 6.70257 1.43306C6.81978 1.55027 6.88562 1.70924 6.88562 1.875C6.88562 2.04076 6.81978 2.19973 6.70257 2.31694C6.58536 2.43415 6.42639 2.5 6.26062 2.5H3.125Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3819 1.60522C13.4945 1.71805 13.5576 1.87088 13.5576 2.03022C13.5576 2.18956 13.4945 2.3424 13.3819 2.45522L7.89945 7.94647C7.84373 8.00222 7.77757 8.04644 7.70475 8.07662C7.63194 8.10679 7.55389 8.12232 7.47507 8.12232C7.39625 8.12232 7.3182 8.10679 7.24539 8.07662C7.17257 8.04644 7.10642 8.00222 7.0507 7.94647C6.93818 7.83365 6.875 7.68081 6.875 7.52147C6.875 7.36213 6.93818 7.2093 7.0507 7.09647L12.5338 1.60522C12.6463 1.49282 12.7989 1.42969 12.9579 1.42969C13.1169 1.42969 13.2694 1.49282 13.3819 1.60522Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.15 1.25C13.4813 1.25 13.75 1.51875 13.75 1.85125V5C13.75 5.33187 13.4563 5.625 13.125 5.625C12.7938 5.625 12.5 5.33187 12.5 5V2.5H10C9.66875 2.5 9.375 2.20688 9.375 1.875C9.375 1.54312 9.64375 1.25 9.975 1.25H13.15Z"
      fill={fill}
    />
  </svg>

)

export default ExternalLinkIcon
